module.exports = __webpack_public_path__ + "static/media/medial-nonflexion.0996571d.png";